module.exports = __webpack_public_path__ + "static/media/boardsofcanada.4f0c005d.gif";